setTimeout(() => {
    (function() {
    console.log("xsell- lazy loading fix")
    const targetHeading = document.querySelector('h3.h4.mb-30.combination-heading');

    // Proceed only if the heading exists
    if (targetHeading) {
        const lazyImages = document.querySelectorAll('img[data-src], img[data-srcset]');

        if (lazyImages.length > 0) {
        const loadImage = function(img) {
            if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            }
            if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            img.removeAttribute('data-srcset');
            }
            if (img.dataset.sizes) {
            img.sizes = img.dataset.sizes;
            img.removeAttribute('data-sizes');
            }
            img.classList.remove('lazy');
            img.classList.add('loaded');
        };

        if (!('IntersectionObserver' in window)) {
            lazyImages.forEach(loadImage);
        } else {
            const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                loadImage(entry.target);
                obs.unobserve(entry.target);
                }
            });
            }, {
            rootMargin: '200px 0px'
            });

            lazyImages.forEach(img => observer.observe(img));
        }
        }
    }
    })();
}, 3000);
